import React, { FC, memo } from 'react'
import SC from '../base/VideoPreview.styles'
import { IVideoPreviewProps } from '../types'
import { VideoPreviewDefaultPlayIcon } from './VideoPreviewDefaultPlayIcon'
import { Video } from '../../Video/desktop'

const {
  Block,
  PreviewOverlayImage,
  Blackout,
  PreviewImage,
  PlayIconWrapper,
  PreviewOverlayWrapper,
} = SC

/** Видео-превью */
const VideoPreview: FC<IVideoPreviewProps> = (props) => {
  const {
    onClick,
    Overlay,
    PlayIcon = VideoPreviewDefaultPlayIcon,
    imgUrl,
    height,
    width,
    size,
    radius = 'large',
    withIcon = true,
    VideoUrl,
    notHover = false,
  } = props

  return (
    <Block height={height} width={width} onClick={onClick}>
      <Blackout notHover={notHover} radius={radius} />

      {withIcon && (
        <PlayIconWrapper>
          <PlayIcon size={size} />
        </PlayIconWrapper>
      )}

      <PreviewOverlayWrapper>
        {typeof Overlay === 'string' ? (
          <PreviewOverlayImage src={Overlay} radius={radius} />
        ) : (
          Overlay
        )}
      </PreviewOverlayWrapper>

      {VideoUrl ? (
        <Video
          video={{
            mp4: VideoUrl,
            webm: VideoUrl,
          }}
          height='100%'
          width='100%'
        />
      ) : (
        <PreviewImage src={imgUrl} />
      )}
    </Block>
  )
}

export { VideoPreview }
export default memo(VideoPreview)
